import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import DeliverySummary from './DeliverySummary';
import SortIcons from './ProposalsSortIcons';
const DeliverySummaryList = ({ faxes, onSort, sortValue }) => {
  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('date')}>
              Date <SortIcons sortObj={sortValue} sortName="date" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => faxes.length > 0 && onSort('totalFaxes')}
            >
              Total Faxes <SortIcons sortObj={sortValue} sortName="totalFaxes" />
            </th>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('success')}>
              Success <SortIcons sortObj={sortValue} sortName="success" />
            </th>
            <th className="cursor-pointer" onClick={() => faxes.length > 0 && onSort('failure')}>
              Failure <SortIcons sortObj={sortValue} sortName="failure" />
            </th>
          </tr>
        </thead>
        <tbody>
          {faxes.length ? (
            faxes.map(fax => <DeliverySummary fax={fax} />)
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Delivery Summary Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(DeliverySummaryList);
